import React, {Component} from 'react';
import { connect } from 'react-redux';
import {annotationStatus} from '../actions';

class WebnotesBar extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		let barClass = this.props.isFetching ? 'webnotes_bar webnotes_waiting' : 'webnotes_bar';
		return (
			<div className={barClass}>
				<div className="webnotes_bar-author">{this.props.annotator}: {this.props.author}</div>
				<a href="/wp-admin/edit.php?post_type=webnotes">{this.props.viewAllSiteNotes}</a>
				<div className="webnotes_bar-add_note">
					<input type="checkbox" id="webnotes_toggle_annotation_mode" checked={this.props.annotationStatus === 'waiting'} onChange={e => this.props.setWaitingStatus(this.props.annotationStatus)} />
					<label for="webnotes_toggle_annotation_mode">{this.props.addNote}</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({annotationStatus: state.annotationStatus, author: state.author });
const mapDispatchToProps = dispatch => {
	return {
		setWaitingStatus: prevAnnotationStatus => {
			dispatch(annotationStatus(prevAnnotationStatus === 'waiting' ? 'inactive' : 'waiting'))
		}
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(WebnotesBar);


// WEBPACK FOOTER //
// ./src/js/components/WebnotesBar.js